export default {
  name: "Nav",
  tel: "Telefûn",
  save: "rizgarkirin",
  confirm: "tesdîqkirin",
  cancel: "Bişûndekirin",
  delete: "lûleêkirin",
  complete: "Qedandin",
  loading: "Loading ...",
  telEmpty: "Ji kerema xwe hejmara telefona xwe dagirin",
  nameEmpty: "Ji kerema xwe navê xwe dagirin",
  nameInvalid: "Ji kerema xwe navek derbasdar binivîse",
  confirmDelete: "Ma hûn guman dikin ku hûn dixwazin wê jêbirin",
  telInvalid: "Ji kerema xwe hejmara telefona rast binivîse",
  vanCalendar: {
    end: "Qedandin",
    start: "destpêkirin",
    title: "nav",
    confirm: "tesdîqkirin",
    startEnd: "Dawiya dest pê bikin",
    weekdays: {
      "0": "roj",
      "1": "yek",
      "2": "du",
      "3": "sê",
      "4": "Çar",
      "5": "pênc",
      "6": "şeş"
    }
  },
  vanCascader: { select: "Ji kerema xwe hilbijêrin" },
  vanContactCard: { addText: "Têkiliyek zêde bikin" },
  vanContactList: { addText: "Kesê têkiliya nû" },
  vanPagination: { prev: "Rûpela berê", next: "Rûpela paşîn" },
  vanPullRefresh: {
    pulling: "Ji nûvekirinê dakêşin ...",
    loosing: "REFRESH BELA ..."
  },
  vanSubmitBar: { label: "gişt:" },
  vanCoupon: { unlimited: "Bê sînorkirinên karanîna" },
  vanCouponCell: { title: "Kupon", tips: "Ne amade ye" },
  vanCouponList: {
    empty: "No kuponan",
    exchange: "berdêl",
    close: "No kuponan",
    enable: "Berdeste",
    disabled: "Ne amade ye",
    placeholder: "Ji kerema xwe kodê daxistinê binivîse"
  },
  vanAddressEdit: {
    area: "dewer",
    postal: "koda postê",
    areaEmpty: "Herêmek hilbijêrin",
    addressEmpty: "Ji kerema xwe navnîşana berfireh dagirin",
    postalEmpty: "Forma kodê ya postê şaş e",
    defaultAddress: "Wekî navnîşa barkirina xwerû destnîşan bikin",
    telPlaceholder: "Hejmara Mobîl Consignee",
    namePlaceholder: "Navê Consignee",
    areaPlaceholder: "Parêzgeh / bajar / navçeyek hilbijêrin"
  },
  vanAddressEditDetail: {
    label: "navnîşan",
    placeholder: "Hejmara deriyê kolanê, hejmara odeya jêrîn û agahdariya din"
  },
  vanAddressList: { add: "Navnîşek zêde bikin" }
};
